// src/pages/CoachHome.jsx
import React from 'react';
import Handbook from './Handbook';
import Expectations from './Expectations';
import Strategies from './Strategies';
import Fundamentals from './Fundamentals';
import NavBar from '../components/NavBar';

const CoachHome = () => {
  return (
    <>
      {/* You can include other coach-related components or content here */}
    </>
  );
};

export default CoachHome;
